import React from 'react'

import {Bar, Pie, Line, Radar, Doughnut, Polar, Bubble, Scatter} from 'react-chartjs-2';

import "./statistics.css"

export default class Chart extends React.Component {

    render() {
        return (
            this.getChart()
        )
    }

    getChart() {

        let chart;

        switch (this.props.chart) {
            case "bar":
                chart = (this.getBar());
                break;
            case "pie":
                chart = (this.getPie());
                break;
            case "line":
                chart = (this.getLine());
                break;
            case "radar":
                chart = (this.getRadar());
                break;
            case "doughnut":
                chart = (this.getDoughnut());
                break;
            case "polar":
                chart = (this.getPolar());
                break;
            case "bubble":
                chart = (this.getBubble());
                break;
            case "scatter":
                chart = (this.getScatter());
                break;
            default:
                chart = (this.getBar())
                break;

        }
        return chart
    }

    getBar() {
        return (
            <Bar
                data={this.props.data}
                options={{
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }

                }}
            />
        )
    }

    getPie() {
        return (
            <Pie
                data={this.props.data}

                width={500}
                height={500}
                options={{
                    maintainAspectRatio: false
                }}
            />
        )
    }

    getLine() {
        return (
            <Line
                data={this.props.data}
                options={{
                    maintainAspectRatio: false
                }}
            />
        )
    }

    getRadar() {
        return (
            <center>
                <div style={{
                    marginTop: 100,
                    marginLeft: 300,
                    width: (window.innerWidth - 350),
                    height: window.innerHeight - 300
                }}>
                    <Radar
                        data={this.props.data}

                        width={500}
                        height={500}
                        options={{
                            maintainAspectRatio: false
                        }}
                    />
                </div>
            </center>
        )
    }

    getDoughnut() {
        return (
            <center>
                <div style={{
                    marginTop: 100,
                    marginLeft: 300,
                    width: (window.innerWidth - 350),
                    height: window.innerHeight - 300
                }}>
                    <Doughnut
                        data={this.props.data}

                        width={500}
                        height={500}
                        options={{
                            maintainAspectRatio: false
                        }}
                    />
                </div>
            </center>
        )
    }

    getPolar() {
        return (
            <center>
                <div style={{
                    marginTop: 100,
                    marginLeft: 300,
                    width: (window.innerWidth - 350),
                    height: window.innerHeight - 300
                }}>
                    <Polar
                        data={this.props.data}

                        width={500}
                        height={500}
                        options={{
                            maintainAspectRatio: false
                        }}
                    />
                </div>
            </center>
        )
    }

    /**
     * Not tested, will probably need it's own parser since format is
     * three axis.
     */
    getBubble() {
        return (
            <center>
                <div style={{
                    marginTop: 100,
                    marginLeft: 300,
                    width: (window.innerWidth - 350),
                    height: window.innerHeight - 300
                }}>
                    <Bubble
                        data={this.props.data}

                        width={500}
                        height={500}
                        options={{
                            maintainAspectRatio: false
                        }}
                    />
                </div>
            </center>
        )
    }

    /**
     * Not tested, will probably need it's own parser since format is
     * three axis.
     */
    getScatter() {
        return (
            <center>
                <div style={{
                    marginTop: 100,
                    marginLeft: 300,
                    width: (window.innerWidth - 350),
                    height: window.innerHeight - 300
                }}>
                    <Scatter
                        data={this.props.data}

                        width={500}
                        height={500}
                        options={{
                            maintainAspectRatio: false
                        }}
                    />
                </div>
            </center>
        )
    }

}
